import {Navigate, Outlet} from "react-router-dom";
import {useContext} from "react";
import AuthContext from "./context/AuthContext";
const PrivateRoute = ({allowedRoles}) => {
    const {user} = useContext(AuthContext);
    // Not logged in
    if (!user) {
        return <Navigate to="/user-login" replace/>;
    }
    // Role check
    if (allowedRoles && !allowedRoles.includes(user.groups)) {
        return <Navigate to="/unauthorized" replace/>;
    }
    return <Outlet/>;
};
export default PrivateRoute;
